import { render, staticRenderFns } from "./admindash.vue?vue&type=template&id=7a7f6ff5&scoped=true&"
import script from "./admindash.vue?vue&type=script&lang=js&"
export * from "./admindash.vue?vue&type=script&lang=js&"
import style0 from "./admindash.vue?vue&type=style&index=0&id=7a7f6ff5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7f6ff5",
  null
  
)

export default component.exports